import { NavLink, Outlet } from "react-router-dom";
import { ChefHat, LayoutDashboard, Package, ClipboardList, Trash2, Monitor } from "lucide-react";

const TABS = [
  { to: "/kitchen",           label: "Dashboard",       icon: LayoutDashboard, end: true, testid: "kops-tab-dashboard" },
  { to: "/kitchen/pantry",    label: "Kitchen Pantry",  icon: Package,                    testid: "kops-tab-pantry" },
  { to: "/kitchen/requests",  label: "Pantry Requests", icon: ClipboardList,              testid: "kops-tab-requests" },
  { to: "/kitchen/waste",     label: "Waste",           icon: Trash2,                     testid: "kops-tab-waste" },
  { to: "/fnb/kds",           label: "Kitchen Display", icon: Monitor,                    testid: "kops-tab-kds" },
];

export default function KitchenShell() {
  return (
    <div className="space-y-6" data-testid="kops-shell">
      <div className="flex items-baseline gap-3">
        <div className="w-11 h-11 rounded-xl bg-hocp-gold flex items-center justify-center shrink-0">
          <ChefHat className="w-5 h-5 text-hocp-eerie" strokeWidth={2}/>
        </div>
        <div>
          <h1 className="font-display text-[26px] font-bold text-hocp-navy leading-none">Kitchen Operations OS</h1>
          <p className="text-[13px] text-slate-500 mt-1.5">
            Kitchen pantry · Pantry approvals · Waste tracking · Supply OS-owned inventory.
          </p>
        </div>
      </div>
      <div className="flex gap-1 border-b border-slate-200 overflow-x-auto">
        {TABS.map(t => {
          const Icon = t.icon;
          return (
            <NavLink key={t.to} to={t.to} end={t.end} data-testid={t.testid}
              className={({ isActive }) =>
                `inline-flex items-center gap-2 px-4 py-2.5 text-[13px] font-medium border-b-2 whitespace-nowrap ${
                  isActive ? "border-hocp-navy text-hocp-navy" : "border-transparent text-slate-500 hover:text-slate-800"
                }`}>
              <Icon className="w-4 h-4" strokeWidth={1.75}/>{t.label}
            </NavLink>
          );
        })}
      </div>
      <Outlet/>
    </div>
  );
}
